import { useEffect, useState } from "react";
import { faqs } from "@/mocks/site";
import { Reveal, SectionHead } from "./ui";

export default function Faq() {
  const [open, setOpen] = useState<number | null>(0);

  // 注入 FAQPage 结构化数据
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = "faq-jsonld";
    const data = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    };
    script.textContent = JSON.stringify(data);
    document.head.appendChild(script);
    return () => {
      document.getElementById("faq-jsonld")?.remove();
    };
  }, []);

  return (
    <section id="faq" className="scroll-mt-20 bg-background-100/60 py-16 md:py-24">
      <div className="mx-auto max-w-[1320px] px-4 md:px-6">
        <SectionHead
          index="06"
          en="FAQ"
          title="常见问题"
          desc="关于吃瓜前线的运作方式、更新频率与信息核实，都在这里。如果你还有别的疑问，欢迎在页面底部联系我们。"
          align="center"
        />

        <Reveal>
          <div className="mx-auto flex max-w-3xl flex-col gap-3">
            {faqs.map((f, i) => {
              const isOpen = open === i;
              return (
                <div
                  key={f.q}
                  className={`overflow-hidden rounded-xl border bg-background-50 transition-colors ${
                    isOpen ? "border-primary-300" : "border-background-200"
                  }`}
                >
                  <button
                    type="button"
                    onClick={() => setOpen(isOpen ? null : i)}
                    aria-expanded={isOpen}
                    className="flex w-full cursor-pointer items-center gap-3 px-5 py-4 text-left"
                  >
                    <span
                      className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-xs font-bold ${
                        isOpen ? "bg-primary-500 text-background-50" : "bg-secondary-100 text-secondary-700"
                      }`}
                    >
                      {isOpen ? <i className="ri-subtract-line" aria-hidden="true"></i> : <i className="ri-add-line" aria-hidden="true"></i>}
                    </span>
                    <h3 className="flex-1 font-heading text-sm font-bold text-foreground-950 md:text-[15px]">
                      {f.q}
                    </h3>
                  </button>
                  <div
                    className={`grid transition-all duration-300 ${
                      isOpen ? "grid-rows-[1fr] opacity-100" : "grid-rows-[0fr] opacity-0"
                    }`}
                  >
                    <div className="overflow-hidden">
                      <p className="px-5 pb-5 pl-[60px] text-sm leading-7 text-foreground-600">{f.a}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </Reveal>
      </div>
    </section>
  );
}